/* Neubau D · Händler-Konzept A „Bestellblock“ (nur ?view=b2b-konzept-a).
   <kka-pad>: Mengen normalisieren (Mindestmenge, Schritt, Höchstmenge), Staffel live je Zeile („noch X bis …“),
   Zeilensummen, Übersicht und mobile Leiste, „In die Tüte“ über /cart/add.js mit denselben Eigenschaften wie
   b2b-order-grid.js, „Nochmal bestellen“, Suche, „Gleiche Menge je Farbe“ (snippets/d-b2b-gleich). Der Entwurf liegt in sessionStorage und gilt für Block und Produktseite.
   <kka-cart>: Mengen und Entfernen im Warenkorb über /cart/change.js, danach neu laden (Preise kommen von Shopify).
   Keine Bewegung, keine Animation. */
(() => {
  const DRAFT_KEY = 'kka-draft-v1';
  const num = (v, d = 0) => { const n = Number.parseInt(v, 10); return Number.isFinite(n) ? n : d; };

  const readDraft = () => { try { return JSON.parse(sessionStorage.getItem(DRAFT_KEY) || '{}') || {}; } catch (_) { return {}; } };
  const writeDraft = (d) => { try { sessionStorage.setItem(DRAFT_KEY, JSON.stringify(d)); } catch (_) { /* privat */ } };

  function normalize(input, raw) {
    let q = Math.max(0, num(raw, 0));
    if (!q) return 0;
    const min = Math.max(1, num(input.dataset.min, 1));
    const inc = Math.max(1, num(input.dataset.inc, 1));
    const max = num(input.dataset.max, 0);
    q = Math.max(q, min);
    if (inc > 1) q = Math.ceil(q / inc) * inc;
    if (max && q > max) q = Math.floor(max / inc) * inc;
    return q;
  }

  function stepValue(input, dir) {
    const q = num(input.value, 0);
    const min = Math.max(1, num(input.dataset.min, 1));
    const inc = Math.max(1, num(input.dataset.inc, 1));
    if (dir > 0) return normalize(input, q === 0 ? min : q + inc);
    const next = q - inc;
    return next < min ? 0 : normalize(input, next);
  }

  function setCartCount(count) {
    document.querySelectorAll('[data-b2b-cart-count], [data-bag-n]').forEach((el) => { el.textContent = count > 0 ? String(count) : ''; });
    document.querySelectorAll('[data-kka-cart-link]').forEach((el) => { el.textContent = `Warenkorb ansehen (${count})`; });
  }

  if (!customElements.get('kka-pad')) {
    customElements.define('kka-pad', class extends HTMLElement {
      connectedCallback() {
        this.fmt = new Intl.NumberFormat(this.dataset.locale || 'de', { style: 'currency', currency: this.dataset.currency || 'EUR' });
        this.form = this.querySelector('[data-kka-form]');
        this.products = Array.from(this.querySelectorAll('[data-kka-product]')).map((el) => {
          let tiers = {};
          try { tiers = JSON.parse(el.querySelector('[data-kka-data]').textContent); } catch (_) { tiers = {}; }
          Object.keys(tiers).forEach((k) => tiers[k].sort((a, b) => a.m - b.m));
          return {
            el,
            name: el.dataset.kkaName,
            key: el.dataset.kkaKey,
            combined: el.dataset.kkaCombined === 'true',
            shared: el.dataset.kkaShared === 'true',
            tiers,
            inputs: Array.from(el.querySelectorAll('[data-kka-qty]')),
          };
        });
        this.inputs = this.products.flatMap((p) => p.inputs);

        const draft = readDraft();
        this.inputs.forEach((input) => {
          const q = draft[input.dataset.variantId];
          if (q && !input.disabled) input.value = String(normalize(input, q));
        });

        this.addEventListener('click', (e) => this.onClick(e));
        this.addEventListener('change', (e) => { if (e.target.matches('[data-kka-qty]')) { e.target.value = String(normalize(e.target, e.target.value)); this.update(); } });
        this.addEventListener('input', (e) => {
          if (e.target.matches('[data-kka-qty]')) this.update(true);
          if (e.target.matches('[data-kka-find]')) this.find(e.target.value);
        });
        this.addEventListener('keydown', (e) => {
          if (e.key === 'Enter' && e.target.matches('[data-kka-qty]')) { e.preventDefault(); e.target.value = String(normalize(e.target, e.target.value)); this.update(); }
          if (e.key === 'Enter' && e.target.matches('[data-kd-gleich-input]')) { e.preventDefault(); this.applyEqual(e.target.closest('[data-kd-gleich]')); }
        });
        if (this.form) this.form.addEventListener('submit', (e) => { e.preventDefault(); this.add(); });
        this.update();
      }

      money(c) { return this.fmt.format(c / 100); }

      activeTier(list, q) { let a = null; for (const t of list || []) if (q >= t.m) a = t; return a; }

      onClick(e) {
        const step = e.target.closest('[data-kka-step]');
        if (step) {
          const input = step.parentElement.querySelector('[data-kka-qty]');
          if (input && !input.disabled) { input.value = String(stepValue(input, num(step.dataset.kkaStep, 1))); this.update(); }
          return;
        }
        const gleich = e.target.closest('[data-kd-gleich-go]');
        if (gleich) { this.applyEqual(gleich.closest('[data-kd-gleich]')); return; }
        if (e.target.closest('[data-kka-clear]')) { this.inputs.forEach((i) => { i.value = '0'; }); this.update(); this.status(''); return; }
        const again = e.target.closest('[data-kka-again]');
        if (again) this.reorder(again);
        const line = e.target.closest('[data-kka-goto]');
        if (line) {
          const input = this.querySelector(`#kka-q-${line.dataset.kkaGoto}`);
          if (input) { e.preventDefault(); input.closest('[data-kka-product]').scrollIntoView({ block: 'center' }); input.focus({ preventScroll: true }); }
        }
      }

      /* „Gleiche Menge je Farbe“: Zahl bei jeder lieferbaren Farbe der Zeile setzen, Mindestmenge/Schritt/Höchstmenge je Farbe
         gelten weiter (wie früher b2b-order-grid.js). Leeres Feld tut nichts, 0 leert alle Farben. */
      applyEqual(box) {
        const field = box && box.querySelector('[data-kd-gleich-input]');
        const row = box && box.closest('[data-kka-product]');
        if (!field || !row) return;
        if (field.value.trim() === '') { field.focus(); return; }
        const want = Math.max(0, num(field.value, 0));
        field.value = String(want);
        let adjusted = false;
        row.querySelectorAll('[data-kka-qty]').forEach((input) => {
          if (input.disabled) return;
          const q = normalize(input, want);
          if (q !== want) adjusted = true;
          input.value = String(q);
        });
        this.update();
        const msg = box.querySelector('[data-kd-gleich-msg]');
        if (msg) msg.textContent = adjusted ? `${box.dataset.done} ${box.dataset.adjusted}` : box.dataset.done;
      }

      /* Rechnet alles neu. live=true: während des Tippens nicht normalisieren, nur rechnen. */
      update(live = false) {
        const draft = readDraft();
        let total = 0; let saving = 0; let packs = 0;
        const lines = [];

        this.products.forEach((p) => {
          const qs = p.inputs.map((i) => (live ? Math.max(0, num(i.value, 0)) : normalize(i, i.value)));
          if (!live) p.inputs.forEach((i, n) => { i.value = String(qs[n]); });
          const family = qs.reduce((s, q) => s + q, 0);
          let rowSum = 0;
          let lead = { q: 0, i: 0 };

          p.inputs.forEach((input, n) => {
            const q = qs[n];
            const vid = input.dataset.variantId;
            const list = p.tiers[vid] || [];
            const base = list.length ? list[0].p : num(input.dataset.price, 0);
            const pq = p.combined ? family : q;
            const t = this.activeTier(list, Math.max(pq, 1));
            const price = t ? t.p : base;
            input.closest('[data-kka-cell]')?.classList.toggle('is-set', q > 0);
            const cellUnit = input.closest('[data-kka-cell]')?.querySelector('[data-kka-cell-unit]');
            if (cellUnit) cellUnit.textContent = this.money(price);
            if (q > lead.q) lead = { q, i: n };
            draft[vid] = q;
            if (!q) { delete draft[vid]; return; }
            rowSum += q * price; packs += q; saving += q * Math.max(0, base - price);
            lines.push({ vid, name: p.name, variant: input.dataset.variant, q, sum: q * price });
          });
          total += rowSum;

          // Zeilenkopf: Stückpreis + „noch X bis …“ (Farbfamilie mit gemeinsamer Staffel: Summe aller Farben).
          const refInput = p.inputs[lead.i];
          const refList = refInput ? (p.tiers[refInput.dataset.variantId] || []) : [];
          const pq = p.combined ? family : (qs[lead.i] || 0);
          const active = this.activeTier(refList, Math.max(pq, 1));
          const unitEl = p.el.querySelector('[data-kka-unit]');
          const nextEl = p.el.querySelector('[data-kka-next]');
          if (unitEl && active) unitEl.textContent = this.money(active.p);
          if (nextEl) {
            const next = refList.find((t) => t.m > pq);
            const who = !p.combined && p.inputs.length > 1 && refInput?.dataset.variant ? `${refInput.dataset.variant}: ` : '';
            let text = '';
            if (pq > 0 && next) text = `${who}noch ${next.m - pq} bis ${this.money(next.p)}`;
            else if (pq > 0 && refList.length > 1) text = `${who}beste Staffel`;
            nextEl.textContent = text;
            nextEl.classList.toggle('is-best', pq > 0 && !next && refList.length > 1);
          }
          p.el.querySelectorAll('[data-kka-tier]').forEach((li) => {
            const on = pq > 0 && active && num(li.dataset.kkaTier, -1) === active.m;
            li.classList.toggle('is-on', !!on);
            if (on) li.setAttribute('aria-current', 'true'); else li.removeAttribute('aria-current');
          });
          const sumEl = p.el.querySelector('[data-kka-sum]');
          if (sumEl) sumEl.textContent = rowSum > 0 ? this.money(rowSum) : '–';
          p.el.classList.toggle('is-set', rowSum > 0);
        });

        writeDraft(draft);
        this.lines = lines;
        this.render({ total, saving, packs, lines });
      }

      render({ total, saving, packs, lines }) {
        const set = (sel, text) => this.querySelectorAll(sel).forEach((el) => { el.textContent = text; });
        set('[data-kka-total]', this.money(total));
        set('[data-kka-bar-total]', this.money(total));
        set('[data-kka-lines-n]', String(lines.length));
        set('[data-kka-packs]', String(packs));
        set('[data-kka-save]', this.money(saving));
        this.querySelectorAll('[data-kka-save-row]').forEach((el) => { el.hidden = saving <= 0; });
        set('[data-kka-bar-count]', lines.length ? `${lines.length} ${lines.length === 1 ? 'Position' : 'Positionen'} · ${packs} Gebinde` : 'Noch nichts gewählt');
        this.querySelectorAll('[data-kka-submit]').forEach((b) => { b.disabled = lines.length === 0 || this.busy; });
        this.querySelectorAll('[data-kka-empty]').forEach((el) => { el.hidden = lines.length > 0; });
        this.querySelectorAll('[data-kka-clear]').forEach((el) => { el.hidden = lines.length === 0; });

        const list = this.querySelector('[data-kka-lines]');
        if (list) {
          list.hidden = lines.length === 0;
          list.replaceChildren(...lines.map((l) => {
            const li = document.createElement('li');
            const a = document.createElement('a');
            a.href = `#kka-q-${l.vid}`;
            a.dataset.kkaGoto = l.vid;
            const name = document.createElement('span');
            name.className = 'kka-sum__name';
            name.textContent = l.variant ? `${l.name} · ${l.variant}` : l.name;
            const q = document.createElement('span');
            q.className = 'kka-sum__q';
            q.textContent = `${l.q}×`;
            const s = document.createElement('b');
            s.textContent = this.money(l.sum);
            a.append(q, name, s);
            li.append(a);
            return li;
          }));
        }
      }

      find(term) {
        const q = term.trim().toLowerCase();
        let hits = 0;
        this.products.forEach((p) => {
          const show = !q || (p.el.dataset.kkaSearch || '').includes(q);
          p.el.hidden = !show;
          if (show) hits += 1;
        });
        this.querySelectorAll('[data-kka-group]').forEach((g) => { g.hidden = !g.querySelector('[data-kka-product]:not([hidden])'); });
        this.querySelectorAll('[data-kka-nohit]').forEach((el) => { el.hidden = hits > 0; });
      }

      reorder(button) {
        let items = [];
        try { items = JSON.parse(button.parentElement.querySelector('[data-kka-again-data]').textContent); } catch (_) { items = []; }
        let taken = 0;
        items.forEach(({ id, q }) => {
          const input = this.querySelector(`#kka-q-${id}`);
          if (input && !input.disabled) { input.value = String(normalize(input, q)); taken += 1; }
        });
        this.update();
        const missing = items.length - taken;
        this.status(missing > 0
          ? `${taken} von ${items.length} Positionen in den Block übernommen. ${missing} gibt es nicht mehr im Sortiment.`
          : `${taken} ${taken === 1 ? 'Position' : 'Positionen'} in den Block übernommen. Prüfen, dann „In die Tüte“.`, taken ? 'ok' : 'error');
      }

      status(text, state = '') {
        this.querySelectorAll('[data-kka-status]').forEach((el) => { el.textContent = text; el.dataset.state = state; });
      }

      async add() {
        const chosen = (this.lines || []).filter((l) => l.q > 0);
        if (!chosen.length || this.busy) return;
        const keyOf = (vid) => this.querySelector(`#kka-q-${vid}`)?.closest('[data-kka-product]')?.dataset.kkaKey || `variant-${vid}`;
        const items = chosen.map((l) => ({
          id: num(l.vid, 0),
          quantity: l.q,
          properties: { _b2b_order: '1', _b2b_pricing: 'per-variant-v1', _b2b_product: keyOf(l.vid) },
        }));
        this.busy = true;
        this.querySelectorAll('[data-kka-submit]').forEach((b) => { b.disabled = true; b.setAttribute('aria-busy', 'true'); });
        this.status('Wird in die Tüte gelegt …');
        try {
          const res = await fetch(this.dataset.cartAddUrl, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ items }),
          });
          if (!res.ok) {
            const problem = await res.json().catch(() => ({}));
            throw new Error(problem.description || problem.message || 'Das hat nicht geklappt. Bitte noch einmal versuchen.');
          }
          const cart = await (await fetch(this.dataset.cartJsonUrl, { headers: { Accept: 'application/json' } })).json();
          const draft = readDraft();
          chosen.forEach((l) => { delete draft[l.vid]; const i = this.querySelector(`#kka-q-${l.vid}`); if (i) i.value = '0'; });
          writeDraft(draft);
          const packs = chosen.reduce((s, l) => s + l.q, 0);
          this.busy = false;
          this.update();
          setCartCount(cart.item_count);
          this.status(`${packs} Gebinde liegen in der Tüte.`, 'ok');
        } catch (err) {
          this.busy = false;
          this.update();
          this.status(err.message, 'error');
        } finally {
          this.querySelectorAll('[data-kka-submit]').forEach((b) => b.removeAttribute('aria-busy'));
        }
      }
    });
  }

  if (!customElements.get('kka-cart')) {
    customElements.define('kka-cart', class extends HTMLElement {
      connectedCallback() {
        this.addEventListener('click', (e) => {
          const step = e.target.closest('[data-kka-step]');
          if (step) {
            const input = step.parentElement.querySelector('[data-kka-cart-qty]');
            if (input) { input.value = String(stepValue(input, num(step.dataset.kkaStep, 1))); this.change(input.dataset.key, num(input.value, 0)); }
            return;
          }
          const x = e.target.closest('[data-kka-remove]');
          if (x) this.change(x.closest('[data-kka-line]').dataset.kkaLine, 0);
        });
        this.addEventListener('change', (e) => {
          if (e.target.matches('[data-kka-cart-qty]')) { e.target.value = String(normalize(e.target, e.target.value)); this.change(e.target.dataset.key, num(e.target.value, 0)); }
        });
        this.addEventListener('keydown', (e) => { if (e.key === 'Enter' && e.target.matches('[data-kka-cart-qty]')) { e.preventDefault(); e.target.blur(); } });
      }

      async change(key, quantity) {
        if (this.busy) return;
        this.busy = true;
        this.querySelectorAll('[data-kka-status]').forEach((el) => { el.textContent = 'Wird aktualisiert …'; el.dataset.state = ''; });
        try {
          const res = await fetch(this.dataset.cartChangeUrl, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ id: key, quantity }),
          });
          if (!res.ok) { const p = await res.json().catch(() => ({})); throw new Error(p.description || p.message || 'Das hat nicht geklappt.'); }
          window.location.reload();
        } catch (err) {
          this.busy = false;
          this.querySelectorAll('[data-kka-status]').forEach((el) => { el.textContent = err.message; el.dataset.state = 'error'; });
        }
      }
    });
  }
})();
